export const URL0 = "https://nao.cuhk.bctshk.com/application";
export const blue = '#7d2882';

//addr area regist exchange nonlocal specific gmap walkforgreen family health
